import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { ItemUsage, type ItemUsageProps } from 'features/ItemUsage/ui/ItemUsage.tsx'

export const showItemUsageModal = (props: ItemUsageProps) => {
  const modalId = nanoid()
  modalStore.addModal({
    paddingContent: '0',
    id: modalId,
    type: ModalTypeList.DEFAULT,
    showHeader: false,
    showCloseButton: false,
    ModalContent: () => <ItemUsage {...props} />,
    primaryAction: {
      onAction: () => {
        modalStore.removeModal(modalId)
      },
      text: 'Close',
    },
  })
}
